import { camsAndForecastsPaths } from './utils/urls/camsAndForecastsPath';
import { mapPaths } from './utils/urls/mapPaths';
import { buoyReportPaths } from './utils/urls/buoyReportPath';
import { spotForecastPaths } from './utils/urls/spotForecastPath';
import { subregionForecastPaths } from './utils/urls/subregionForecastPath';
import { subregionForecastChartsPaths } from './utils/urls/subregionForecastChartsPath';

export const CamAndForecastsRoute = {
  routeProps: {
    path: camsAndForecastsPaths.base,
    exact: true,
  },
  loader: () =>
    import(
      /* webpackChunkName: "CamsAndForecasts" */
      './containers/routes/CamsAndForecasts'
    ),
  loading: () => null,
  modules: ['./containers/routes/CamsAndForecasts'],
  webpack: () => [require.resolveWeak('./containers/routes/CamsAndForecasts')],
};

export const BuoyGeonameMap = {
  routeProps: {
    path: mapPaths.geonameBuoys,
  },
  loader: () =>
    import(
      /* webpackChunkName: "BuoyGeonameMap" */
      './containers/BuoyGeonameMap'
    ),
  loading: () => null,
  modules: ['./containers/BuoyGeonameMap'],
  webpack: () => [require.resolveWeak('./containers/BuoyGeonameMap')],
};

export const GeonameMapRoute = {
  routeProps: {
    path: `${camsAndForecastsPaths.base}/*/:geonameId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "GeonameMap" */
      './containers/routes/GeonameMap'
    ),
  loading: () => null,
  modules: ['./containers/routes/GeonameMap'],
  webpack: () => [require.resolveWeak('./containers/routes/GeonameMap')],
};

export const BuoyMap = {
  routeProps: {
    // Order matters here, it will pick the first match. Be careful if you change this
    // it may lead to the location param not being returned
    path: [mapPaths.buoysWithLocation, mapPaths.buoys],
  },
  loader: () =>
    import(
      /* webpackChunkName: "BuoyMap" */
      './containers/BuoyMap'
    ),
  loading: () => null,
  modules: ['./containers/BuoyMap'],
  webpack: () => [require.resolveWeak('./containers/BuoyMap')],
};

export const MapPageV2Route = {
  routeProps: {
    path: [
      // Order matters, it will match the closest one first. Be careful if you change this
      // it may change the params being returned
      mapPaths.buoysWithLocation,
      mapPaths.geonameBuoys,
      mapPaths.buoys,
    ],
  },
  loader: () =>
    import(
      /* webpackChunkName: "MapV2" */
      './containers/routes/MapV2'
    ),
  loading: () => null,
  modules: ['./containers/routes/MapV2'],
  webpack: () => [require.resolveWeak('./containers/routes/MapV2')],
  childRoutes: [BuoyMap, BuoyGeonameMap],
};

export const MapPageRoute = {
  routeProps: {
    path: `${camsAndForecastsPaths.base}-${camsAndForecastsPaths.map}(/@)?:location?`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "Map" */
      './containers/routes/Map'
    ),
  loading: () => null,
  modules: ['./containers/routes/Map'],
  webpack: () => [require.resolveWeak('./containers/routes/Map')],
};

export const SpotPageRoute = {
  routeProps: {
    path: spotForecastPaths.report,
  },
  loader: () =>
    import(
      /* webpackChunkName: "Spot" */
      './containers/routes/Spot'
    ),
  loading: () => null,
  modules: ['./containers/routes/Spot'],
  webpack: () => [require.resolveWeak('./containers/routes/Spot')],
};

export const PremiumAnalysisRoute = {
  routeProps: {
    path: `${subregionForecastPaths.base}/:subregionName/:subregionId/${subregionForecastPaths.premiumAnalysis}`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "PremiumAnalysis" */
      './containers/routes/SubregionForecastPage/PremiumAnalysis'
    ),
  loading: () => null,
  modules: ['./containers/routes/SubregionForecastPage/PremiumAnalysis'],
  webpack: () => [require.resolveWeak('./containers/routes/SubregionForecastPage/PremiumAnalysis')],
};

export const SubregionForecastRoute = {
  routeProps: {
    exact: true,
    path: `${subregionForecastPaths.base}/:subregionName/:subregionId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SubregionForecast" */
      './containers/routes/SubregionForecastPage/SubregionForecast'
    ),
  loading: () => null,
  modules: ['./containers/routes/SubregionForecastPage/SubregionForecast'],
  webpack: () => [
    require.resolveWeak('./containers/routes/SubregionForecastPage/SubregionForecast'),
  ],
};

export const SubregionForecastPageRoute = {
  routeProps: {
    path: `${subregionForecastPaths.base}/:subregionName/:subregionId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SubregionForecastPage" */
      './containers/routes/SubregionForecastPage'
    ),
  loading: () => null,
  modules: ['./containers/routes/SubregionForecastPage'],
  webpack: () => [require.resolveWeak('./containers/routes/SubregionForecastPage')],
  childRoutes: [SubregionForecastRoute, PremiumAnalysisRoute],
};

export const ChartsPageRoute = {
  routeProps: {
    path: `${subregionForecastChartsPaths.base}/:chartSlug/:subregionName/:subregionId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "ChartsPage" */
      './containers/routes/SubregionForecastPage/Charts'
    ),
  loading: () => null,
  modules: ['./containers/routes/SubregionForecastPage/Charts'],
  webpack: () => [require.resolveWeak('./containers/routes/SubregionForecastPage/Charts')],
};

export const ChartsPageContainerRoute = {
  routeProps: {
    isMultiPage: true,
    path: `${subregionForecastChartsPaths.base}/:chartSlug/:subregionName/:subregionId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SubregionForecastPage" */
      './containers/routes/SubregionForecastPage'
    ),
  loading: () => null,
  modules: ['./containers/routes/SubregionForecastPage'],
  webpack: () => [require.resolveWeak('./containers/routes/SubregionForecastPage')],
  childRoutes: [ChartsPageRoute],
};

export const SessionsClipRoute = {
  routeProps: {
    path: `/sessions/clips/:clipId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SessionsClip" */
      './containers/routes/SessionsClip'
    ),
  loading: () => null,
  modules: ['./containers/routes/SessionsClip'],
  webpack: () => [require.resolveWeak('./containers/routes/SessionsClip')],
};

export const SessionRoute = {
  routeProps: {
    path: `/sessions/:sessionId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SessionPage" */
      './containers/routes/Sessions'
    ),
  loading: () => null,
  modules: ['./containers/routes/Sessions'],
  webpack: () => [require.resolveWeak('./containers/routes/Sessions')],
};

export const SurfCamsRoute = {
  routeProps: {
    path: '/surf-cams',
    exact: true,
  },
  loader: () =>
    import(
      /* webpackChunkName: "SurfCams" */
      './containers/routes/SurfCams'
    ),
  loading: () => null,
  modules: ['./containers/routes/SurfCams'],
  webpack: () => [require.resolveWeak('./containers/routes/SurfCams')],
};

export const BuoyRoute = {
  routeProps: {
    path: buoyReportPaths.base,
  },
  loader: () =>
    import(
      /* webpackChunkName: "BuoyPage" */
      './containers/routes/BuoyPage'
    ),
  loading: () => null,
  modules: ['./containers/routes/BuoyPage'],
  webpack: () => [require.resolveWeak('./containers/routes/BuoyPage')],
};

export const CamRewindRoute = {
  routeProps: {
    path: `/surf-cams/:spotName/:camId`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "CamRewind" */
      './containers/routes/CamRewind'
    ),
  loading: () => null,
  modules: ['./containers/routes/CamRewind'],
  webpack: () => [require.resolveWeak('./containers/routes/CamRewind')],
};

export const RateLimitTestPage = {
  routeProps: {
    path: `/rl-test-page/`,
  },
  loader: () =>
    import(
      /* webpackChunkName: "RateLimitRoute" */
      './containers/routes/RateLimitTestPage'
    ),
  loading: () => null,
  modules: ['./containers/routes/RateLimitTestPage'],
  webpack: () => [require.resolveWeak('./containers/routes/RateLimitTestPage')],
};

const NotFoundRoute = {
  routeProps: {
    path: '*',
    status: 404,
  },
  loader: () =>
    import(
      /* webpackChunkName: "NotFound" */
      './containers/routes/NotFound'
    ),
  loading: () => null,
  modules: ['./containers/routes/NotFound'],
  webpack: () => [require.resolveWeak('./containers/routes/NotFound')],
};

export default [
  CamAndForecastsRoute,
  MapPageV2Route,
  GeonameMapRoute,
  MapPageRoute,
  SpotPageRoute,
  SubregionForecastPageRoute,
  ChartsPageContainerRoute,
  SessionsClipRoute,
  SessionRoute,
  BuoyRoute,
  CamRewindRoute,
  RateLimitTestPage,
  NotFoundRoute,
];
